import React, { useEffect, useState } from 'react';
import { interveneFilterAtom, leadDetailObjAtom, userDetailAtom, userInfoByNumberAtom, userInformationAtom, WhatsAppTempFormAtom } from '../../../Services/_states';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { TemplateActions } from '../../../Services/_actions/Template/template.actions';
import { useLocation } from 'react-router-dom';
import SweetAlert from '../../Shared/Notification';
import SendTemplateForm from '../../Whatsapp/Template/sendTemplateForm';
import ErrorWrapper from '../../Shared/ErrorWrapper';
import { Button } from '@mui/material';

export const QuickTemplateModal = ({
  quickTemplates,
  setShowQuickTempModal,
  phoneNumber,
  botNumber,
}) => {
  const tempActions = TemplateActions();
  // const location = useLocation();
  const userDetails = useRecoilValue(userDetailAtom);
  const interveneFilter = useRecoilValue(interveneFilterAtom);
  const userInfoByNumber = useRecoilValue(userInfoByNumberAtom);
  const leadDetails = useRecoilValue(leadDetailObjAtom);
  const loggedInUser = useRecoilValue(userInformationAtom);
  const setWhatsappTempFormData = useSetRecoilState(WhatsAppTempFormAtom);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [paramasObj, setParamasObj] = useState({});
  const [filters, setFilters] = useState({ page: 0, search: '', channelObj: null, botNumber: '', sortField: 'created_at', sortOrder: 'desc', category: '' });
  const [validationError, setValidationError] = useState({});
  const resolvedPhoneNumber = phoneNumber || userDetails?.phone_number || '';
  const resolvedBotNumber = botNumber || interveneFilter?.botNumber || '';

  const validateData = () => {
    let errors = {};
    selectedTemplate?.param?.map((item) => {
      if (!paramasObj[item])
        errors[item] = `${item} field is required`
    })
    setValidationError(errors);
    return Object.keys(errors)?.length;
  }

  const SendTemplate = async () => {
    let paramArr = Object.values(paramasObj);
    let error = validateData();
    if (error) {
      SweetAlert("Please Fill all required field", "warning");
      return 0
    }
    let dataObj = [
      {
        phone_number: resolvedPhoneNumber,
        template_id: selectedTemplate?.id,
        default_params: selectedTemplate?.param,
        params: paramArr,
        botNumber: resolvedBotNumber,
      },
    ];
    await tempActions.sendTemplate(dataObj);
    setShowQuickTempModal(false);
  };

  const handleChange = (e, item) => {
    let obj = paramasObj;
    obj[item] = e?.target?.value || '';
    setParamasObj(obj);
  };

  // const searchTemplateByName = async (text) => {
  //   let res = await tempActions.getTemplateList({
  //     page: 0,
  //     search: text,
  //     botNumber: interveneFilter?.botNumber,
  //   });
  //   if (res?.status === 200) {
  //     try {
  //       setSelectedTemplate(res?.data?.rows[0]);
  //     } catch {
  //       setSelectedTemplate({});
  //     }
  //   }
  // };
  const searchTemplateByName = async (text) => {
    let obj = { ...filters, botNumber: resolvedBotNumber, search: text };
    let res = await tempActions.getWhatsappTemplateList(obj);
    if (res?.list?.length > 0) {
      setWhatsappTempFormData(res?.list[0]);
      setSelectedTemplate(res?.list[0]);

      // if (res?.list[0]?.messaging_product === 'whatsapp')
      //   setWhatsappTempFormData(res?.list[0]);
      // else setSelectedTemplate(res?.list[0]);
    }
    else setSelectedTemplate({});
  };


  const divideKeyType = (str) => {
    const [role, ...keyParts] = str?.split('_');
    const key = keyParts?.join('_');
    return { type: role, key: key }
  }

  const getDataFromLeadForm = (keyName) => {
    if (leadDetails[keyName]) {
      return leadDetails[keyName] || ''
    } else {
      let foundObject = Object.values(leadDetails?.leads_form_items)?.find(obj => obj?.key_name === keyName);
      return foundObject?.value || '';
    }
  }

  const getDataFromUserDetailsByNuber = (keyName) => {
    if (userInfoByNumber[keyName]) {
      return userInfoByNumber[keyName] || ''
    } else {
      let foundObject = userInfoByNumber?.data?.find(obj => obj?.column_name === keyName);
      return foundObject?.value || '';
    }
  }

  const handleParams = () => {
    let params = selectedTemplate?.param || []; //['agent_first_name', 'lead_Whatsapp Number:', "user_area"];
    let paramsObj = {};
    params?.forEach((item) => {
      let data = divideKeyType(item);
      switch (data?.type) {
        case 'agent':
          paramsObj[item] = loggedInUser[data?.key];
          break;

        case 'user':
          paramsObj[item] = getDataFromUserDetailsByNuber(data?.key);
          break;

        case 'lead':
          paramsObj[item] = getDataFromLeadForm(data?.key);
          break;
        default:
          paramsObj[item] = ''
      }
    })
    setParamasObj(paramsObj)
  }

  useEffect(() => {
    // let queryParams = new URLSearchParams(location.search);
    // let params = {};
    // for (let [key, value] of queryParams?.entries()) {
    //   params[key] = value;
    // }
    handleParams();

    // setQueryParams(params);
  }, [selectedTemplate]);

  return (
    <>
      <div
        style={{
          marginBottom: '10px',
          display: 'flex',
          flexWrap: 'wrap',
          // justifyContent: 'center',
          gap: '10px',
          // alignItems: 'center',
        }}
      >
        {' '}
        {quickTemplates?.map((item, index) => {
          return (
            <Button
              variant={selectedTemplate?.md_id === item?.md_id ? "contained" : "outlined"}
              key={index}
              onClick={() => searchTemplateByName(item?.alias_name || item?.name)}
            >
              {item?.alias_name || item?.name}
            </Button>
          );
        })}
      </div>
      <SendTemplateForm phoneNumber={userDetails?.phone_number} leadId={leadDetails?.id} />

      {/* {selectedTemplate?.messaging_product === "whatsapp" ?
        <SendTemplateForm phoneNumber={userDetails?.phone_number} />
        :
        <div>
          {selectedTemplate?.data && (
            <p>
              <strong>Message : </strong> {selectedTemplate?.data ? selectedTemplate?.data : ''}.
            </p>
          )}
          <Row>
            {selectedTemplate &&
              selectedTemplate?.param?.map((item, index) => {
                return (
                  <div className="col-4" key={index}>
                    <FormGroup className="my-2">
                      <Form.Control
                        type="text"
                        placeholder={item}
                        defaultValue={paramasObj[item] || ''}
                        onChange={(e) => {
                          handleChange(e, item);
                        }}
                        isInvalid={validationError[item]}
                      />
                      {validationError[item] && (
                        <ErrorWrapper error={validationError[item]} />
                      )}
                    </FormGroup>
                  </div>
                );
              })}
          </Row>
          <Button
            variant="primary"
            style={{ marginTop: '10px' }}
            onClick={() => {
              SendTemplate();
            }}
            disabled={!selectedTemplate?.id}
          >
            Send
          </Button>
        </div>
      } */}
    </>
  );
};
